module.exports = __webpack_public_path__ + "img/LineIconsPro Regular.365c563.svg";